module.exports = __webpack_public_path__ + "img/noData_filter.5516ccaa.svg";